import { handleUpRating, handleOpenFeedback } from "../helpers";
import { serverUrl } from "../../data/dataApi";
import ActionsMenu from "./ActionsMenu";

const MessageActions = ({ message, messageIndex, messages, setMessages, sessionInfo, feedbackDetails, onChatError, setMessageKey, onFeedbackDetailsChange, onFeedbackOpen, userEmail, onSubmit, setQuery }) => {

    const handleTryAgain = () => {
        // Find the user message that preceded this API response
        const userMessage = messages[messageIndex - 1];
        if (!userMessage || userMessage.type !== 'userMessage') {
            console.error('Could not find preceding user message');
            return;
        }

        // Get the original question (without reply text or image markdown)
        const originalQuestion = userMessage.originalQuestion || userMessage.message;

        // Remove this API response and the user message before it, then resubmit
        setMessages(prevMessages => prevMessages.slice(0, messageIndex - 1));

        // Trigger the submit with the original query
        setTimeout(() => {
            onSubmit(null, originalQuestion);
        }, 0);
    };

    const handleAddDetails = () => {
        // Find the user message that preceded this API response
        const userMessage = messages[messageIndex - 1];
        if (!userMessage || userMessage.type !== 'userMessage') {
            console.error('Could not find preceding user message');
            return;
        }

        // Get the original question
        const originalQuestion = userMessage.originalQuestion || userMessage.message;

        // Remove this API response and the user message before it, then resubmit with detail instruction
        setMessages(prevMessages => prevMessages.slice(0, messageIndex - 1));

        // Resubmit with hidden instruction for more detail
        setTimeout(() => {
            onSubmit(null, originalQuestion, 'Please provide a more detailed response.');
        }, 0);
    };

    const handleMoreConcise = () => {
        // Find the user message that preceded this API response
        const userMessage = messages[messageIndex - 1];
        if (!userMessage || userMessage.type !== 'userMessage') {
            console.error('Could not find preceding user message');
            return;
        }

        // Get the original question
        const originalQuestion = userMessage.originalQuestion || userMessage.message;

        // Remove this API response and the user message before it, then resubmit with concise instruction
        setMessages(prevMessages => prevMessages.slice(0, messageIndex - 1));

        // Resubmit with hidden instruction for more concise response
        setTimeout(() => {
            onSubmit(null, originalQuestion, 'Please provide a more concise response.');
        }, 0);
    };

    const handleCopyMessage = async () => {
        try {
            let messageText = message.message || message.text || '';

            // Remove HTML tags (citations divs, etc.)
            messageText = messageText.replace(/<[^>]*>/g, '');

            // Remove image markdown syntax: ![alt](url)
            messageText = messageText.replace(/!\[([^\]]*)\]\(([^\)]+)\)/g, '');

            // Decode HTML entities
            const textarea = document.createElement('textarea');
            textarea.innerHTML = messageText;
            messageText = textarea.value;

            // Clean up extra whitespace and blank lines
            messageText = messageText
                .split('\n')
                .map(line => line.trim())  // Remove leading/trailing spaces from each line
                .join('\n')
                .replace(/\n{3,}/g, '\n\n')  // Replace 3+ newlines with 2
                .trim();

            await navigator.clipboard.writeText(messageText);
        } catch (err) {
            console.error('Failed to copy message:', err);
        }
    };

    return (
        <div className="rating-btn-wrapper d-flex justify-content-center align-items-center flex-shrink-0 tif-mt-35 tif-mx-auto tif-py-10 tif-px-20 flex-grow-0">
            <button className="message-action-btn border-0 tif-p-0 bg-transparent" onClick={handleCopyMessage} title="Copy message">
                <svg id="copy" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path id="Path_9543" data-name="Path 9543" d="M0,0H24V24H0Z" fill="none" />
                    <path id="Path_9544" data-name="Path 9544" d="M7,9.667A2.667,2.667,0,0,1,9.667,7h8.666A2.667,2.667,0,0,1,21,9.667v8.666A2.667,2.667,0,0,1,18.333,21H9.667A2.667,2.667,0,0,1,7,18.333V9.667" fill="none" stroke="#98a9b3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    <path id="Path_9545" data-name="Path 9545" d="M4.012,16.737A2,2,0,0,1,3,15V5A2.006,2.006,0,0,1,5,3H15a1.606,1.606,0,0,1,1.5,1" fill="none" stroke="#98a9b3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                </svg>
            </button>
            <ActionsMenu
                wrapperClassName="start-0"
                trigger={
                    <button className="message-action-btn border-0 tif-p-0 bg-transparent" title="Regenerate response">
                        <svg id="Group_12481" data-name="Group 12481" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path id="Path_9546" data-name="Path 9546" d="M0,0H24V24H0Z" fill="none" />
                            <path id="Path_9547" data-name="Path 9547" d="M20,11A8.1,8.1,0,0,0,4.5,9M4,5V9H8" fill="none" stroke="#98a9b3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                            <path id="Path_9548" data-name="Path 9548" d="M4,13a8.1,8.1,0,0,0,15.5,2m.5,4V15H16" fill="none" stroke="#98a9b3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                        </svg>
                    </button>
                }
            >
                {({ onItemClick }) => (
                    <>
                        <button
                            type="button"
                            className="w-100 text-start border-0"
                            onClick={onItemClick(handleTryAgain)}
                        >
                            <svg id="Group_12481" data-name="Group 12481" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path id="Path_9546" data-name="Path 9546" d="M0,0H24V24H0Z" fill="none" />
                                <path id="Path_9547" data-name="Path 9547" d="M20,11A8.1,8.1,0,0,0,4.5,9M4,5V9H8" fill="none" stroke="#98a9b3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                <path id="Path_9548" data-name="Path 9548" d="M4,13a8.1,8.1,0,0,0,15.5,2m.5,4V15H16" fill="none" stroke="#98a9b3" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                            </svg>
                            Try again
                        </button>
                        <button
                            type="button"
                            className="w-100 text-start border-0"
                            onClick={onItemClick(handleAddDetails)}
                        >
                            <svg id="Group_12482" data-name="Group 12482" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path id="Path_9549" data-name="Path 9549" d="M0,0H24V24H0Z" fill="none" />
                                <path id="Path_9550" data-name="Path 9550" d="M19,10H5" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9551" data-name="Path 9551" d="M5,6H19" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9552" data-name="Path 9552" d="M14,14H5" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9553" data-name="Path 9553" d="M5,18h6" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9554" data-name="Path 9554" d="M18,15v6" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9555" data-name="Path 9555" d="M15,18h6" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </svg>

                            Add details
                        </button>
                        <button
                            type="button"
                            className="w-100 text-start border-0"
                            onClick={onItemClick(handleMoreConcise)}
                        >
                            <svg id="Group_12483" data-name="Group 12483" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                                <path id="Path_9556" data-name="Path 9556" d="M0,0H24V24H0Z" fill="none" />
                                <path id="Path_9557" data-name="Path 9557" d="M4,6h7" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9558" data-name="Path 9558" d="M4,12h7" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9559" data-name="Path 9559" d="M4,18h9" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9560" data-name="Path 9560" d="M15,9l3-3,3,3" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                                <path id="Path_9561" data-name="Path 9561" d="M18,6V18" fill="none" stroke="#98a9b3" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" />
                            </svg>
                            More concise
                        </button>
                    </>
                )}
            </ActionsMenu>
            <p className="tif-mb-0 fw-bold tif-color-oscar">Are my answers helpful so far?</p>
            {message.rating !== "down" && (
                <button
                    className="message-up-rate-btn bg-transparent border-0 tif-p-0"
                    data-feedback-id={message.ratingId ?? ""}
                    onClick={(e) => handleUpRating(e, messageIndex, messages, setMessages, sessionInfo, feedbackDetails, onChatError, userEmail)}
                >
                    {message.rating === "up" ? (
                        <img
                            src={`${serverUrl}/static/assets/thumb-up-green-icon.svg`}
                            alt="Thumb up green icon"
                        />
                    ) : (
                        <>
                            <img
                                src={`${serverUrl}/static/assets/thumb-up-icon.svg`}
                                alt="Thumb up icon"
                                className="rest-icon"
                            />
                            <img
                                src={`${serverUrl}/static/assets/thumb-up-blue-icon.svg`}
                                alt="Thumb up blue icon"
                                className="hover-icon"
                            />
                        </>
                    )}
                </button>
            )}
            {message.rating !== "up" && (
                <button
                    className="message-down-rate-btn bg-transparent border-0 tif-p-0"
                    onClick={() => handleOpenFeedback(messageIndex, setMessageKey, onFeedbackDetailsChange, onFeedbackOpen, messages)}
                >
                    {message.rating === "down" ? (
                        <img
                            src={`${serverUrl}/static/assets/thumb-down-red-icon.svg`}
                            alt="Thumb up red icon"
                        />
                    ) : (
                        <>
                            <img
                                src={`${serverUrl}/static/assets/thumb-down-icon.svg`}
                                alt="Thumb down icon"
                                className="rest-icon"
                            />
                            <img
                                src={`${serverUrl}/static/assets/thumb-down-blue-icon.svg`}
                                alt="Thumb down blue icon"
                                className="hover-icon"
                            />
                        </>
                    )}
                </button>
            )}
        </div>
    );
};

export default MessageActions;